import React from "react";

function Dots({value,warn}){
  const c=warn?"#e53935":value>=4?"#43a047":value>=3?"#fb8c00":"#e53935";
  return <div style={{display:"flex",gap:3}}>{Array.from({length:5},(_,i)=><div key={i} style={{width:9,height:9,borderRadius:2,background:i<value?c:"#e8e3d8"}}/>)}</div>;
}
function water(ws){
  const s={surplus:5,adequate:4,stress:2,scarce:1}[ws]??3;
  const n={surplus:"Goede watervoorziening heel jaar",adequate:"Voldoende, extra opslag aanbevolen",stress:"⚠ Droogtestress — waterput + opvang nodig",scarce:"⛔ Structureel tekort — moeilijk voor farm"}[ws]||"Status onbekend";
  return {score:s,note:n,warn:s<=2};
}
function pdm(zs){
  if(!zs) return {score:2,note:"PDM niet beschikbaar — check gemeente",warn:true};
  const t=zs.toLowerCase();
  if(t.includes("agro")||t.includes("turismo rural")) return {score:5,note:"Agro-toerisme expliciet mogelijk"};
  if(t.includes("rústico")||t.includes("rustico")||t.includes("solo rural")) return {score:4,note:"Landelijk gebruik toegestaan"};
  if(t.includes("reserva")||t.includes("parque natural")) return {score:2,note:"Beschermd gebied — beperkingen",warn:true};
  if(t.includes("urbano")) return {score:2,note:"Stedelijk bestemming, agro moeilijk",warn:true};
  return {score:3,note:"Gemengd — vergunning mogelijk, onderzoek"};
}
function groeiseizoen(mm){
  if(!mm||mm.length<12) return {score:3,note:"Temperatuurdata ontbreekt"};
  const m=mm.filter(t=>t>=10).length;
  return {score:m>=11?5:m>=10?4:m>=8?3:2,note:`${m} maanden groeiseizoen (gem. max ≥ 10°C)`};
}
function brand(fc){
  const f=fc??3;
  return {score:f<=1?5:f<=2?4:f===3?3:f===4?2:1,note:f<=2?"Laag brandrisico":f===3?"Gemiddeld — brandpaden verplicht":"Hoog risico — verzekering duur",warn:f>=4};
}
function al(v){
  if(v===true)  return {score:5,note:"Open gebied — AL-vergunning aanvraagbaar"};
  if(v==="restricted") return {score:3,note:"Beperkt contingent beschikbaar"};
  if(v===false) return {score:1,note:"⛔ Moratorium actief",warn:true};
  return {score:3,note:"Status controleren bij gemeente"};
}
const PRICES=[
  [["algarve"],"€8k–22k/ha"],[["costa de lisboa","sintra","cascais"],"€6k–18k/ha"],
  [["setúbal","sesimbra"],"€4k–10k/ha"],[["alentejo litoral","costa vicentina"],"€3k–8k/ha"],
  [["alentejo"],"€2k–5k/ha"],[["centro","óbidos","peniche","nazaré"],"€3k–8k/ha"],
  [["norte","minho"],"€4k–9k/ha"],
];
function landprijs(region){
  const r=(region||"").toLowerCase();
  for(const[ks,p] of PRICES){if(ks.some(k=>r.includes(k))) return p;}
  return "€3k–10k/ha";
}

export function FarmPotential({town,concelho}){
  if(!town||!concelho) return null;
  const cl=concelho.climate||{};
  const wF=water(concelho.water_status);
  const pF=pdm(concelho.zoning_summary);
  const gF=groeiseizoen(cl.monthly_temp_max);
  const bF=brand(concelho.fire_risk_class);
  const aF=al(concelho.al_open);
  const pr=landprijs(town.region);
  const factors=[
    {icon:"💧",label:"Water",...wF},
    {icon:"📋",label:"Bestemmingsplan",...pF},
    {icon:"🌱",label:"Groeiseizoen",...gF},
    {icon:"🔥",label:"Brandrisico",...bF},
    {icon:"🏡",label:"AL-vergunning",...aF},
  ];
  const avg=factors.reduce((s,f)=>s+f.score,0)/factors.length;
  const ov=Math.round(avg*10)/10;
  const bc=ov>=4?"#43a047":ov>=3?"#fb8c00":"#e53935";
  const bl=ov>=4?"Sterke farmlocatie":ov>=3?"Potentieel aanwezig":"Uitdagende locatie";
  const blockers=factors.filter(f=>f.score<=2);
  const [lo,hi]=pr.replace(/[€k\/ha\s]/g,"").split("–").map(Number);
  const hText=lo&&hi?`≈ ${Math.round(200/hi)}–${Math.round(200/lo)} ha bij €200k`:null;
  return (
    <section className="tm-section">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <h4 className="tm-section-h4" style={{margin:0}}>🌾 Wellness Farm Potentie</h4>
        <span style={{fontSize:11,fontWeight:600,color:bc,background:bc+"18",padding:"3px 10px",borderRadius:20,flexShrink:0}}>{bl}</span>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:8,marginBottom:10}}>
        {factors.map(f=>(
          <div key={f.label} style={{background:f.warn?"#fff5f5":"#faf8f4",borderRadius:8,padding:"9px 10px",border:`1px solid ${f.warn?"#fcc":"#ede8de"}`}}>
            <div style={{fontSize:20,marginBottom:5}}>{f.icon}</div>
            <div style={{fontSize:11,fontWeight:600,color:"#555",marginBottom:5}}>{f.label}</div>
            <Dots value={f.score} warn={f.warn}/>
            <div style={{fontSize:10,color:"#999",marginTop:5,lineHeight:1.35}}>{f.note}</div>
          </div>
        ))}
        <div style={{background:"#faf8f4",borderRadius:8,padding:"9px 10px",border:"1px solid #ede8de"}}>
          <div style={{fontSize:20,marginBottom:5}}>💶</div>
          <div style={{fontSize:11,fontWeight:600,color:"#555",marginBottom:4}}>Grondprijs</div>
          <div style={{fontSize:14,fontWeight:700,color:"#333",marginBottom:2}}>{pr}</div>
          <div style={{fontSize:10,color:"#999",lineHeight:1.35}}>agrarisch land (indicatief)</div>
        </div>
      </div>
      <div style={{background:"#f0f7ee",borderRadius:8,padding:"9px 12px",fontSize:11,color:"#555",lineHeight:1.6}}>
        <strong>💡 Budget bij €750k:</strong> ~€380k woning + ~€200k grond {hText?`(${hText})`:""}+ ~€170k renovatie & inrichting
      </div>
      {blockers.length>0&&(
        <div style={{marginTop:8,background:"#fff3f3",borderRadius:8,padding:"9px 12px",fontSize:11,color:"#c94040",lineHeight:1.5}}>
          <strong>⚠ Let op:</strong> {blockers.map(b=>`${b.icon} ${b.label}: ${b.note}`).join(" · ")}
        </div>
      )}
      <div style={{marginTop:8,fontSize:11}}>
        <a href="https://www.dgterritorio.gov.pt/cadastro-e-ordenamento/ordenamento-do-territorio/planos-territoriais" target="_blank" rel="noopener" style={{color:"#2d5a8e",textDecoration:"none"}}>📎 PDM opzoeken op DGT →</a>
      </div>
    </section>
  );
}
